import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

const API = '/api';

export function useDocumentView(documentId) {
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadDocument = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/documents/view/${documentId}`);
      setDocument(response.data);
    } catch (err) {
      setError(err.response?.data?.detail || 'Erreur lors du chargement du document');
    } finally {
      setLoading(false);
    }
  }, [documentId]);

  useEffect(() => {
    loadDocument();
  }, [loadDocument]);

  return {
    document,
    loading,
    error,
  };
}
